import DropdownSIMSSchool from "root/s360components/ui/DropdownSIMSSchool";
import React, { useState} from "react";
import TeacherLoadManager from "root/s360components/TeacherLoad/TeacherLoadManager";

const TeacherLoadContainer = ({}) =>
{
    const [encSchoolId, setSchoolId ] = useState ( null ) ;

    const onSchoolChange = ( params ) =>
    {
        console.log ( params ) ;

        setSchoolId( params.enc_school_id ) ;
    }

    return (
        <div className='sims-admin-container'>
            <h2>Non-Teaching Staff Loader</h2>
            <p>This screen allows loading of Staff into School360 where the users are not marked as Teachers in the school MIS</p>
            <p style={{color: '#b77171'}}>Only Staff loaded from MIS systems connected to Wonde can be loaded here.</p>
            <label>Please select a school</label>
            <DropdownSIMSSchool onChange={onSchoolChange}/>
            <TeacherLoadManager enc_school_id={encSchoolId} />
        </div>
    )
}

export default TeacherLoadContainer;